module.exports = __webpack_public_path__ + "img/evenware-logo.455cadc9.png";